import { usePickerContext } from "./usePickerContext"
import { useEffect } from "react"

export function useResponsiveMarkers() {
    const {dispatch} = usePickerContext();

    function onResize() {
        let device = 'desktop';
        if (window.innerWidth <= 768) device = 'tablet';
        if (window.innerWidth <= 576) device = 'phone';
        dispatch({type: 'SET_RESPONSIVE_DEVICE', payload: device})
    }

    useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
}